import request from './request';

export const changePassword = (data) =>
  request({
    url: '/changePassword',
    method: 'post',
    data
  });
